import { gql } from '@apollo/client';

export const GET_CLIENT_BILLING_REPORT = gql`
  query GetClientBillingReport(
    $startDate: String!,
    $endDate: String!,
    $clientName: String,
    $department: String,
    $userId: String
  ) {
    getClientBillingReport(
      startDate: $startDate,
      endDate: $endDate,
      clientName: $clientName,
      department: $department,
      userId: $userId
    ) {
      records {
        requestId
        clientName
        department
        totalSeconds
        totalHours
        sessionCount
        tasks {
          taskType
          totalSeconds
          totalHours
          sessionCount
          source
        }
        employees
      }
      totalCount
      grandTotalSeconds
      grandTotalHours
    }
  }
`;
